module.exports = __webpack_public_path__ + "img/assembly_lvl.bfdd531e.png";